
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/platforms/pricing-table-for-wix",
      function () {
        return require("private-next-pages/help-centre/platforms/pricing-table-for-wix.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/platforms/pricing-table-for-wix"])
      });
    }
  